import React, { useEffect, useState, useRef, useContext } from "react";
import { connect } from "react-redux";
import { useHistory } from "react-router";
import moment from "moment/moment";
import LeaveRequestForm from "../../helpers/LeaveRequestForm";
import SocketContext from "helpers/SocketContext";
import StatusLayout from "components/Status";

import FormDialog from "../../helpers/FormDialog";
import { AddBoxSharp } from "@mui/icons-material";
import {
  Button,
  Card,
  Dialog,
  DialogContent,
  Typography,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TextField,
  DialogTitle,
  DialogActions,
  ListItem,
  ListItemButton,
  ListItemAvatar,
  Avatar,
  ListItemText,
} from "@mui/material";
import { blue } from "@mui/material/colors";

// Import helpers and components
import { mapStateToProps } from "../../store/helpers/mapState";
import { mapDispatchToProps } from "../../store/helpers/mapDispatch";
import DatatableComponent from "../../helpers/DatatableComponent";
import OpenDocument from "../../helpers/openDocument";
import { getFileMime, getError } from "../../store/helpers/common_functions";
import axios from "axios";
import { errorToast, successToast } from "helpers/Notification";
import { getMyLineManager } from "helpers/Common_functions";

function SimpleDialog(props) {
  const { onClose, selectedValue, open, items } = props;

  const handleClose = () => {
    onClose(selectedValue);
  };

  const handleListItemClick = (value) => {
    onClose(value);
  };

  return (
    <Dialog onClose={handleClose} open={open}>
      <DialogTitle>Request Category</DialogTitle>
      <DialogContent>
        <div
          className="grid"
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(2, 1fr)", // Three columns
          }}
        >
          {items.map((item) => (
            <div key={item.id} style={{ margin: 0 }}>
              <ListItem disableGutters>
                <ListItemButton onClick={() => handleListItemClick(item)}>
                  <ListItemAvatar>
                    <Avatar sx={{ bgcolor: blue[100], color: blue[600] }}>
                      <AddBoxSharp />
                    </Avatar>
                  </ListItemAvatar>
                  <ListItemText primary={item.name} />
                </ListItemButton>
              </ListItem>
            </div>
          ))}
        </div>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => onClose(null)}>Cancel</Button>
      </DialogActions>
    </Dialog>
  );
}

function RequestApproval({ SetSelectedMenu, systemSettings, FetchDetails, loggedUser }) {
  const mainBackground = systemSettings?.mainBackground;

  // State variables
  const [tableData, setTableData] = useState([]);
  const [refreshKey, setRefreshKey] = useState(0);
  const [fileView, setFileView] = useState(null);
  const [statusCounts, setStatusCounts] = useState({
    approved: 0,
    rejected: 0,
    pending: 0,
  });
  const [pendingLeaves, setPendingLeaves] = useState([]);
  const [pendingDialogOpen, setPendingDialogOpen] = useState(false);
  const [selectedCard, setSelectedCard] = useState("all");
  const [open, setOpen] = useState(false);
  const [selectedValue, setSelectedValue] = useState(null);
  const [categories, setCategories] = useState([]);
  const [formOpen, setFormOpen] = useState(false);
  const [value, setValue] = useState({});
  // const [lineManagers, setLineManagers] = useState([]);
  const [info, setInfo] = useState(null);
  const [selectedStatus, setSelectedStatus] = useState("all");
  const [totalLeavesCount, setTotalLeavesCount] = useState(0);
  const [cancellingId, setCancellingId] = useState(null);
  const [cancelDialogOpen, setCancelDialogOpen] = useState(false);
  const [myLineManager, setMyLineManager] = useState([]);


  const statuses = [
    { label: "All", value: "all" },
    { label: "Approved", value: "approved" },
    { label: "First Approval", value: "first-approval" },
    { label: "Pending-review", value: "pending-review" },
    { label: "Rejected", value: "denied" },
  ];

  const history = useHistory();
  const socket = useContext(SocketContext);

  const calculateDaysRemaining = (endDate) => {
    const end = moment(endDate, "YYYY-MM-DD");
    if (!end.isValid()) {
      return 0;
    }
    const currentDate = moment();
    const daysRemaining = end.diff(currentDate, "days");
    return Math.max(daysRemaining, 0);
  };

  const loadCategories = async () => {
    try {
      const resp = await axios.get("/api/request/categories/");
      if (resp.data && resp.data.categories) {
        setCategories(resp.data.categories);
      }
    } catch (error) { }
  };

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = (value) => {
    setOpen(false);
    if (value) {
      setFormOpen(true);
    }
    setSelectedValue(value);
  };

  useEffect(() => {
  }, [loggedUser]);

useEffect(() => {
  const getmyReportingLine = async () => {
    const myLineManager = await getMyLineManager(loggedUser);
    setMyLineManager(myLineManager || null); 
  };
  getmyReportingLine();
}, [loggedUser]);



  const getLineManagers = async () => {
    try {
      const resp = await axios.get("/api/role/my-line-managers/");
      if (resp.data && resp.data.data) {
        const listItem = resp.data.data;
        const managersList = [];
        for (const item of listItem) {
          const resourceList = item?.lineManager?.Resources || [];
          for (const resource of resourceList) {
            managersList.push(resource);
          }
        }
        // Remove or comment out this line since setLineManagers is not defined
        // setLineManagers(
        //   managersList.map((v) => ({
        //     label: v?.acting
        //       ? `${v?.actor?.names} (acting on behalf of ${v?.names})`
        //       : v.names,
        //     value: v?.acting ? v.actor.id : v.id,
        //   }))
        // );
        return managersList; // Optional: return the managers list if needed
      }
    } catch (error) { }
  };

  const loadData = async () => {
    try {
      const resp = await axios.get("/api/request/requests/info");
      if (resp.data) {
        setInfo(resp.data);
      }
    } catch (error) { }
  };

  const fetchStatusCounts = async () => {
    try {
      const response = await axios.get("/api/approval/status-count", {
        params: { user: "loggedin" },
      });
      if (response.data) {
        setStatusCounts({
          approved: response.data.approved || 0,
          rejected: response.data.denied || 0,
          pending: response.data.pending || 0,
        });
      }
    } catch (error) {
      setStatusCounts({
        approved: 0,
        rejected: 0,
        pending: 0,
      });
    }
  };

  const fetchTotalLeavesCount = async () => {
    try {
      const response = await axios.get("/api/approval/datatable", {
        params: { type: "all", user: "loggedin" },
      });
      // Count all leaves, including canceled
      setTotalLeavesCount(response.data.data.length);
    } catch (error) { }
  };

  const fetchPendingLeaves = async () => {
    try {
      const response = await axios.get("/api/approval/datatable", {
        params: { type: "pending-review", user: "loggedin" },
      });
      const firstApprovalResponse = await axios.get("/api/approval/datatable", {
        params: { type: "first-approval", user: "loggedin" },
      });

      const combinedLeaves = [
        ...(response.data.data || []).map((leave) => ({
          ...leave,
          categoryLabel: "Pending Review",
        })),
        ...(firstApprovalResponse.data.data || []).map((leave) => ({
          ...leave,
          categoryLabel: "First Approval",
        })),
      ];

      const uniqueLeaves = Array.from(
        new Set(combinedLeaves.map((item) => item.id))
      ).map((id) => combinedLeaves.find((item) => item.id === id));

      setPendingLeaves(uniqueLeaves);
      setPendingDialogOpen(true);
    } catch (error) { }
  };

  const fetchAllLeaves = async () => {
    try {
      const response = await axios.get("/api/approval/datatable", {
        params: { type: selectedStatus, user: "loggedin" },
      });
      const leaves = response.data.data || [];
      setTableData(leaves);
      setRefreshKey((prevKey) => prevKey + 1);
    } catch (error) {
      setTableData([]);
    }
  };

  const handleCancelRequest = async (requestId) => {
    setCancellingId(requestId);
    try {
      const resp = await FetchDetails(`/api/request/cancel/${requestId}`, {
        method: "POST",
      });
      if (resp.status) {
        await fetchAllLeaves();
        await fetchStatusCounts();
        setCancelDialogOpen(false);
        successToast("Request cancelled successfully");
      } else {
        errorToast(getError(resp) || "Failed to cancel request");
      }
    } catch (e) {
      errorToast(e?.message || "Failed to cancel request");
    }
    setCancellingId(null);
  };

  useEffect(() => {
    const preloadData = async () => {
      await loadCategories();
      // await getLineManagers();
    };

    SetSelectedMenu({
      menu: "leave-overview",
      title: "Leave Overview",
    });

    preloadData();
    loadData();
    fetchTotalLeavesCount();
    fetchStatusCounts();
  }, [SetSelectedMenu]);

  useEffect(() => {
    if (selectedStatus === "pending-review,first-approval") {
      fetchPendingLeaves();
    } else {
      fetchAllLeaves();
    }
  }, [selectedStatus]);

  const otherColumns = [
    {
      name: "category.name",
      label: "Leave Type",
      options: {
        filter: true,
        sort: true,
        customBodyRenderLite: (dataIndex, rowIndex) => (
          <div
            style={{
              border: "1px solid #0764E6",
              backgroundColor: "#E6EFFC",
              borderRadius: "10px",
              padding: "5px 10px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              color: "#0764E6",
              whiteSpace: "nowrap",
            }}
          >
            {tableData[rowIndex]?.category?.name || "N/A"}
          </div>
        ),
      },
    },
    {
      name: "startDate",
      label: "Start Date",
      options: {
        filter: true,
        sort: true,
        customBodyRenderLite: (dataIndex, rowIndex) => {
          const date = moment(tableData[rowIndex]?.startDate);
          return date.isValid() ? (
            <span style={{ color: "#0043FF" }}>{date.format("MMM DD")}</span>
          ) : (
            "N/A"
          );
        },
      },
    },
    {
      name: "endDate",
      label: "End Date",
      options: {
        filter: true,
        sort: true,
        customBodyRenderLite: (dataIndex, rowIndex) => {
          const date = moment(tableData[rowIndex]?.endDate);
          return date.isValid() ? (
            <span style={{ color: "#0043FF" }}>{date.format("MMM DD")}</span>
          ) : (
            "N/A"
          );
        },
      },
    },
    {
      name: "leaveDays",
      label: "Days Taken",
      options: {
        filter: true,
        sort: true,
        customBodyRenderLite: (dataIndex, rowIndex) => {
          const startDate = moment(tableData[rowIndex]?.startDate);
          const endDate = moment(tableData[rowIndex]?.endDate);
          return startDate.isValid() && endDate.isValid()
            ? startDate.businessDiff(endDate)
            : "N/A";
        },
      },
    },
    {
      name: "id",
      label: "Days Left",
      options: {
        filter: true,
        sort: true,
        customBodyRenderLite: (dataIndex, rowIndex) => {
          const endDate = tableData[rowIndex]?.endDate;
          const daysRemaining = calculateDaysRemaining(endDate);
          return <Typography>{daysRemaining}</Typography>;
        },
      },
    },
    {
      name: "status",
      data: "status",
      label: "Status",
      options: {
        customBodyRender: (v) => <StatusLayout status={v} />,
      },
    },
    {
      name: "id",
      label: "Action",
      options: {
        filter: false,
        sort: false,
        customBodyRender: (v, tableMeta) => {
          const rowIndex = tableMeta.rowIndex;
          let status = tableData?.[rowIndex]?.status;
          let endDate = tableData?.[rowIndex]?.endDate;

          if (
            typeof status === "string" &&
            ["canceled", "denied"].includes(status.trim().toLowerCase())
          ) {
            return null;
          }
          // Hide button if current date >= end date
          if (endDate) {
            const now = moment().startOf("day");
            const leaveEnd = moment(endDate, "YYYY-MM-DD").endOf("day");
            if (now.isSameOrAfter(leaveEnd)) {
              return null;
            }
          }
          return (
            <Button
              variant="contained"
              color="error"
              onClick={(e) => {
                e.stopPropagation(); // Prevent row click
                setCancellingId(v);
                setCancelDialogOpen(true);
              }}
              sx={{
                minWidth: "120px",
                maxWidth: "120px",
                width: "120px",
                fontSize: "12px",
                textAlign: "center",
                borderRadius: "10px",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
                "&:hover": {
                  backgroundColor: "#b71c1c",
                },
              }}
            >
              Cancel Leave
            </Button>
          );
        },
      },
    },
  ];

  const onRowClick = (data, { rowIndex, event }) => {
    const actionColIndex = otherColumns.findIndex(
      (col) => col.name === "id" && col.label === "Action"
    );
    if (
      event &&
      event.target &&
      event.target.closest &&
      event.target.closest("button")
    ) {
      return;
    }
    history.push(`/admin/permission/details/${tableData[rowIndex].id}`);
  };

  const statusCardColors = {
    all: { background: mainBackground, color: "white" },
    approved: { background: "green", color: "white" },
    "first-approval": { background: "#FF9800", color: "white" },
    "pending-review": { background: "#FFA400", color: "white" },
    denied: { background: "#F44336", color: "white" },
    rejected: { background: "#F44336", color: "white" },
    pending: { background: "#2196F3", color: "white" },
  };

  const renderStatusCard = (count, icon, title, cardKey) => {
    const colors = statusCardColors[cardKey] || {
      background: "white",
      color: "black",
    };
    return (
      <Grid item xs={3}>
        <Card
          className="p-4 cursor-pointer"
          style={{
            height: "140px",
            borderRadius: "12px",
            boxShadow: "0 4px 10px rgba(0, 0, 0, 0.1)",
            backgroundColor: colors.background,
            color: colors.color,
            transition: "background-color 0.3s ease",
            border:
              selectedCard === cardKey
                ? `2px solid ${colors.background}`
                : "none",
          }}
          onClick={() => {
            setSelectedCard(cardKey);
            if (cardKey === "pending-review" || cardKey === "pending") {
              setSelectedStatus(
                "pending-review,first-approval,under-review,second-approval"
              );
            } else if (cardKey === "approved") {
              setSelectedStatus("approved,on-leave");
            } else {
              setSelectedStatus(cardKey);
            }
          }}
        >
          <div className="flex justify-between items-start mb-2">
            <Typography
              variant="h4"
              className="font-bold text-left p-3"
              style={{ fontSize: "50px" }}
            >
              {count}
            </Typography>
            <i className={`${icon} text-primary text-4xl p-4`} />
          </div>
          <Typography
            variant="h6"
            className="font-semibold text-left"
            style={{ marginLeft: "16px", marginTop: "4px" }}
          >
            {title}
          </Typography>
        </Card>
      </Grid>
    );
  };

  return (
    <div>
      <SimpleDialog
        selectedValue={selectedValue}
        open={open}
        items={categories}
        onClose={handleClose}
      />

      {/* File View Dialog */}
      <Dialog
        maxWidth="md"
        fullWidth
        open={fileView !== null}
        onClose={() => setFileView(null)}
      >
        <DialogContent>
          {fileView && (
            <OpenDocument
              downloadable
              document={fileView?.supportDocument}
              name="supportDocument"
              specialName={fileView?.supportDocument}
              type="permission-doc"
              mimeType={getFileMime(fileView?.supportDocument)}
            />
          )}
        </DialogContent>
      </Dialog>

      {/* Cancel Confirmation Dialog */}
      <Dialog
        open={cancelDialogOpen}
        onClose={() => {
          setCancelDialogOpen(false);
          setCancellingId(null);
        }}
      >
        <DialogTitle>Cancel Leave Request</DialogTitle>
        <DialogContent>
          <Typography>Are you sure you want to cancel this leave ?</Typography>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              setCancelDialogOpen(false);
              setCancellingId(null);
            }}
          >
            No
          </Button>
          <Button
            color="error"
            onClick={() => handleCancelRequest(cancellingId)}
            disabled={!cancellingId}
          >
            Yes, Cancel
          </Button>
        </DialogActions>
      </Dialog>

      {formOpen && selectedValue && info && (
        <LeaveRequestForm
          open={formOpen}
          setOpen={() => {
            setSelectedValue(null);
            setFormOpen(false);
          }}
          selectedValue={selectedValue}
          categories={categories}
          info={info}
          onSuccess={() => {
            fetchAllLeaves();
            fetchStatusCounts();
          }}
          socket={socket}
          myLineManager={myLineManager}
        />
      )}

      {/* Status Cards */}
      <Grid container spacing={3} className="mb-4">
        {renderStatusCard(totalLeavesCount, "fas fa-list", "All Leaves", "all")}
        {renderStatusCard(
          statusCounts.approved,
          "fas fa-check-circle",
          "Approved",
          "approved"
        )}
        {renderStatusCard(
          statusCounts.pending,
          "fas fa-hourglass-half",
          "Pending",
          "pending-review"
        )}
        {renderStatusCard(
          statusCounts.rejected,
          "fas fa-times-circle",
          "Rejected",
          "denied"
        )}
      </Grid>

      {/* Data Table */}
      <Card>
        <DatatableComponent
          key={refreshKey}
          onAddNew={() => handleClickOpen()}
          search={false}
          searchfield={true}
          viewColumns={false}
          onRowClick={onRowClick}
          processData={(data) => {
            const fullData = data.data;
            const processedLeaves = fullData.map((req) => ({
              ...req,
              startDate: moment(req.startDate).format("YYYY-MM-DD"),
              endDate: moment(req.endDate).format("YYYY-MM-DD"),
            }));
            setTableData(processedLeaves);
            return { ...data, data: processedLeaves };
          }}
          url={`/api/approval/datatable?type=${selectedStatus}&user=loggedin`}
          columns={otherColumns}
          title={<span className="font-semibold">All Leaves</span>}
          options={{
            filter: true,
            filterType: "dropdown",
            responsive: "standard",
            search: true,
            searchOpen: true,
            selectableRows: "none",
            download: false,
            print: false,
          }}
        />
      </Card>
    </div>
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(RequestApproval);
